export default {
	"components.UnbindAccount": "解绑账号"
}